import type { BrandItem } from '@/types';

const LEGACY_NEXTOP_APP_IDS = new Set(['233749', 'nextop']);

export function isNextopBrand(
  brand: Pick<BrandItem, 'id' | 'name' | 'appId' | 'customAppId'> | null,
) {
  if (!brand) {
    return false;
  }

  return [brand.id, brand.name, brand.appId, brand.customAppId]
    .filter(Boolean)
    .some((value) => LEGACY_NEXTOP_APP_IDS.has(value?.trim().toLowerCase() ?? ''));
}
